<template>
    <div id="solution">
        <div class="solution1">
            <img :src="url+banner.images[2]" alt=""  @click="jumpbannerpage(banner.url,2)">
        </div>
        <div class="solution2">
            <p class="title">珠宝服装等零售行业的痛点</p>
            <!-- <ul>
                <li v-for="(item,index) in solution2" :key="index"  class="wow animate__animated animate__fadeInRight">
                    <img :src="item.icon" alt="">
                    <p class="p1">{{item.title}}</p>
                    <p class="p2">{{item.subtitle}}</p>
                </li>
            </ul> -->
            <div>
                <img src="@/assets/solution/solutionicon2.png" alt=""  class="wow animate__animated animate__fadeIn">
            </div>
        </div>
        <div class="solution3">
            <img src="@/assets/solution/solution3Bg.png" alt="" class="bg">
            <div class="solution3Box">
                <p class="title">累积服务10000+商家，指标提升倍增</p>
                <ul>
                    <li v-for="(item,index) in solution3" :key="index"  class="wow animate__animated animate__fadeIn">
                        <img :src="item.icon" alt="">
                        <div>
                            <p class="p1" v-html="item.title"></p>
                            <p class="p2">{{item.subtitle}}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="solution4">
            <ul>
                <li v-for="(item,index) in solution4" :key="index"  class="wow animate__animated animate__fadeIn">
                    <div>
                        <p class="p1">{{item.title}}</p>
                        <p class="p2">{{item.subtitle}}</p> 
                        <img :src="item.icon" alt="">
                     </div>
                </li>
            </ul>
        </div>
        <mydialog v-if="showtc2" @tcstatus="tcstatus" :dialogVisible1="tcshow"></mydialog>
    </div>
</template>

<script>
var that
import { rotationmap } from '@/api/api'
import mydialog from '@/components/dialog/dialog.vue'
export default {
    name:"solution",
    components: {
        mydialog
    },
    data(){
        return {
            showtc2:false,
            url : window.url,
            banner:{},

            solution3:[
                {
                    icon:require('@/assets/solution/solutionicon3.png'),
                    title:"45<span>%</span>",
                    subtitle:"客户留存率增长",
                },
                 {
                    icon:require('@/assets/solution/solutionicon4.png'),
                    title:"57<span>%</span>",
                    subtitle:"营业收入增长",
                },
                {
                    icon:require('@/assets/solution/solutionicon5.png'),
                    title:"57<span>%</span>",
                    subtitle:"私域复购率",
                },
                {
                    icon:require('@/assets/solution/solutionicon6.png'),
                    title:"57<span>%</span>",
                    subtitle:"触达客户量增长",
                }
            ],
            solution4:[
                {
                    icon:require('@/assets/solution/solutionicon7.png'),
                    title:"亿宝易帮你解决痛点打造零售营销新生态",
                    subtitle:"打造一套完整的引流拓客、运营维护、社群营销、用户管理、裂变转化的闭环体系",
                },
                {
                    icon:require('@/assets/solution/solutionicon8.png'),
                    title:"线下客户倒流到私域微信号或社群内最好有效客户沉淀",
                    subtitle:"线下门店客户是非常高质量的客户群体，使用亿宝易系统内的活码功能、短信营销、红包裂变、引流链接等功能将老客户、新客户倒流到私域流量池，形成客户沉淀 ",
                },
                {
                    icon:require('@/assets/solution/solutionicon9.png'),
                    title:"搭建线上店铺，配合线下一起营销，降低线下成本提升总体转化",
                    subtitle:"可以利用亿宝易小程序开设自己的线上门店，并且还配有店铺朋友圈以及优惠券、拼团等多种营销工具可以使用最大限度满足商家需求和客户体验。",
                },
                {
                    icon:require('@/assets/solution/solutionicon10.png'),
                    title:"组建完整社群运营体系，提升社群活跃度和成交转化",
                    subtitle:"私域流量基于社群开展的私域运营与成交转化，提升私域运营效率。并通过群活码、群红包、群发等社群运营工具，提升私域客户粘性及活跃度，进而提升成交额。",
                },
                {
                    icon:require('@/assets/solution/solutionicon11.png'),
                    title:"会员模式精准触达，轻松实现复购",
                    subtitle:"通过会员体系和积分体系的运营，刺激用户活跃，培养忠诚度，促进业务增长，针对不同阶段的客户制定不同的营销策略促使会员复购",
                },
                {
                    icon:require('@/assets/solution/solutionicon12.png'),
                    title:"完善的数据系统助力有效监管，统计决策",
                    subtitle:"精确统计各项运营数据，客户行为追踪，多维度数据记录，全面洞察营销效果，科学助力营销决策",
                },
                {
                    icon:require('@/assets/solution/solutionicon13.png'),
                    title:"亿宝易系统提供完整顾客经营数字化解决方案",
                    subtitle:"帮助实体门店搭建私域流量池，构建可持续发展的顾客经营体系",
                }
            ]
        }
    },
    mounted(){
        that = this
        //初始化动画
        rotationmap({'type':5}).then((response) => {
            response.data.data[0].images = response.data.data[0].images.split(',')
            that.banner = response.data.data[0]
            this.$nextTick(()=>{
                this.$wow.init()
            })
        })
        
    },
    methods:{
        tcstatus(e){
            this.showtc2 = e
        },
        submit(e){
            this.showtc2 = true
            this.tcshow = e
        },
        jumpbannerpage(e,y){
            this.showtc2 = true
            let url = e.split(',')
            if(url[y] != this.$route.path) {
                this.$router.push(url[y])
            }
        }
    }
}
</script>

<style lang="less">
:root {
    --web-title-fontsize: 30px;
    --web-subtitle-fontsize: 22px;
    --web-text-fontsize: 16px;
} 
@media (min-width:750px) {
    #solution{
        .solution1{
            img{
                width: 100%;
            }
        }
        .solution2{
            margin:0 auto 0;
            background: linear-gradient(180deg, rgba(218,230,254,0.8) 0%, #F9FBFF 100%);
            padding: 70px 0;
            .title{
                font-size: var(--web-title-fontsize);
                font-weight: 800;
                color: #222222;
                text-align: center;
            }
            img{
                width: 1189px;
                display: block;
                margin:53px auto 120px;
            }
        }
        .solution3{
            position: relative;
            .bg{
                width: 100%;
            }
            .solution3Box{
                position: absolute;
                top: 33px;
                left: 50%;
                transform: translateX(-50%);
                width: 1300px;
                .title{
                    font-size: var(--web-title-fontsize);
                    font-weight: 800;
                    color: #FFFFFF;
                    text-align: center;
                }
                ul{
                    background: #FFFFFF;
                    box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                    border-radius: 20px 20px 20px 20px;
                    display: flex;
                    margin-top: 20px;
                    padding: 40px 60px;
                    justify-content: space-between;
                    li{
                        display: flex;
                        align-items: center;
                        img{
                            width: 100px;
                            margin-right: 12px;
                        }
                        .p1{
                            font-size: var(--web-subtitle-fontsize);
                            font-weight: 800;
                            color: #222222;
                            font-size: 64px;
                            span{
                                font-size: 32px;
                            }
                        }
                        .p2{
                            font-size: var(--web-text-fontsize);
                            font-weight: normal;
                            color: #474747;
                        }
                    }
                }
            }
        }
        .solution4{
            margin-top: 180px;
            ul{
                li{
                    background: linear-gradient(180deg, #EFF4FF 0%, rgba(197,214,255,0) 100%);
                    margin-bottom: 100px;
                    div{
                        width: 1300px;
                        margin:0 auto;
                        padding: 80px 0;
                    }
                    .p1{
                        font-size: var(--web-title-fontsize);
                        font-weight: 800;
                        color: #222222;
                        text-align: center;
                        margin-bottom: 20px;
                    }
                    .p2{
                        width: 1000px;
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: 500;
                        color: #808080;
                        text-align: center;
                        margin:0 auto 49px;
                    }
                    img{
                        width: 806px;
                        display: block;
                        margin:0 auto 60px;
                    }
                }
            }
        }
    }
}
@media screen and (max-width:750px) {
     #solution{
        .solution1{
            img{
                width: 100%;
            }
            
        }
        .solution2{
            margin:0 auto 0;
            background-color: #F5F8FF;
            padding: 1.875rem 0;
            .title{
                font-size: 1.5rem;
                font-weight: 800;
                color: #222222;
                text-align: center;
            }
            img{
                width: 90%;
                display: block;
                margin:20px auto 30px;
            }
        }
        .solution3{
            position: relative;
            .bg{
                width: 100%;
            }
            .solution3Box{
                position: absolute;
                top: 0.4375rem;
                left: 50%;
                transform: translateX(-50%);
                width: 100%;
                .title{
                    font-size: 1.5rem;
                    font-weight: 800;
                    color: #FFFFFF;
                    text-align: center;
                }
                ul{
                    background: #FFFFFF;
                    box-shadow: 0rem 0.1875rem 0.375rem 0.0625rem rgba(0,0,0,0.16);
                    border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
                    display: flex;
                    margin-top: 1.25rem;
                    padding: 0.625rem 1.875rem;
                    justify-content: space-between;
                    margin:1.25rem 0.625rem;
                    flex-wrap: wrap;
                    li{
                        flex:0 0 50%;
                        display: flex;
                        align-items: center;
                        img{
                            width: 1.25rem;
                            margin-right: 0.75rem;
                        }
                        .p1{
                            font-size: 0.875rem;
                            font-weight: 800;
                            color: #222222;
                            span{
                                font-size: 1rem;
                            }
                        }
                        .p2{
                            font-size: 0.625rem;
                            font-weight: normal;
                            color: #474747;
                        }
                    }
                }
            }
        }
        .solution4{
            margin-top: 8.75rem;
            ul{
                width: 100%;
                margin:0 auto;
                li{
                    .p1{
                        font-size: 1.5rem;
                        font-weight: 800;
                        color: #222222;
                        text-align: center;
                        margin-bottom: 1.25rem;
                    }
                    .p2{
                        width: 90%;
                        font-size: 1.25rem;
                        font-weight: 500;
                        color: #808080;
                        text-align: center;
                        margin:0 auto 3.0625rem;
                    }
                    img{
                        width: 100%;
                        margin-bottom: 3.75rem;
                    }
                }
            }
        }
    }
 
}
</style>